import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HrPerOrganizationTreeComponent } from './hr-per-organization-tree.component';
import { PrimengSharedModule, HvlNgSharedModule } from '@hvlng/framework-core/shared';
import { UiSharedModule } from 'ui-shared';
import { TreeModule } from 'primeng/tree';
import { TranslateModule } from '@ngx-translate/core';
import { HvlFormItemModule } from '@hvlng/framework-core/form';
import { AccordionModule } from 'primeng/accordion';
import { MenuModule } from 'primeng/menu';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { TreeTableModule } from 'primeng/treetable';
import { HrPerPersonnelSearchModule } from '../../../personnel-operations/component/hr-per-personnel-search/hr-per-personnel-search.module';
import { TableModule } from 'primeng/table';
import { OrgTreePersonnelListComponent } from './org-tree-common-component/pos-personnel-list/org-tree-personnel-list.component';
import { ChartUnitDetailComponent } from './org-tree-common-component/chart-unit-detail/chart-unit-detail.component';
import { HrPerOrgUnitPosWithParentPickerModule } from '../hr-per-org-unit-pos-with-parent-picker/hr-per-org-unit-pos-with-parent-picker.module';
import { ToolbarModule } from "primeng/toolbar";
import {TreeDragDropService} from "primeng/api";
import {TriStateCheckboxModule} from "primeng/tristatecheckbox";
import {OrgMoveComponent} from "../org-move/org-move.component";
import {HrPerOrgUnitPosPickerModule} from "../hr-per-org-unit-pos-picker/hr-per-org-unit-pos-picker.module";

@NgModule({
    declarations: [HrPerOrganizationTreeComponent, OrgTreePersonnelListComponent, ChartUnitDetailComponent,OrgMoveComponent],
    imports: [
        CommonModule,
        PrimengSharedModule,
        HvlNgSharedModule,
        UiSharedModule,
        TreeModule,
        TranslateModule,
        HvlFormItemModule,
        AccordionModule,
        MenuModule,
        OrganizationChartModule,
        TreeTableModule,
        HrPerPersonnelSearchModule,
        TableModule,
        HrPerOrgUnitPosWithParentPickerModule,
        ToolbarModule,
        TriStateCheckboxModule,
        HrPerOrgUnitPosPickerModule,
    ],
    exports: [HrPerOrganizationTreeComponent,OrgMoveComponent,OrgTreePersonnelListComponent],
    providers:[TreeDragDropService]
})
export class HrPerOrganizationTreeModule {}
